import { inject, Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { BlogpostDetail, BlogpostInput, BlogpostSummary, PagingResponse, TagFilter } from '../models/cms-models';

@Injectable({
  providedIn: 'root',
})
export class BlogpostsService {
  private apiService = inject(ApiService);

  async getSiteBlogposts(siteId: string, filter?: TagFilter): Promise<BlogpostSummary[]> {
    const response = await this.apiService.get<PagingResponse<BlogpostSummary>>(
      `api/blogpost/site/${siteId}`,
      this.buildTagQuery(filter),
    );
    return response.data;
  }

  async getBlogpost(blogpostId: string): Promise<BlogpostDetail> {
    return this.apiService.get<BlogpostDetail>(`api/blogpost/${blogpostId}`);
  }

  async createBlogpost(blogpost: BlogpostInput): Promise<BlogpostDetail> {
    return this.apiService.post<BlogpostDetail, BlogpostInput>('api/blogpost', blogpost);
  }

  async updateBlogpost(blogpostId: string, blogpost: BlogpostInput): Promise<BlogpostDetail> {
    return this.apiService.put<BlogpostDetail, BlogpostInput>(`api/blogpost/${blogpostId}`, blogpost);
  }

  async deleteBlogpost(blogpostId: string): Promise<void> {
    await this.apiService.delete(`api/blogpost/${blogpostId}`);
  }

  private buildTagQuery(filter?: TagFilter): Record<string, string | string[]> | undefined {
    if (!filter || !filter.tags.length) {
      return undefined;
    }

    return {
      tags: filter.tags,
      tagMode: filter.tagMode,
    };
  }
}
